import { get, post, put } from "Service";

const caseStatus = (caseTypeId: number) => {
  const request = {
    subUrl: `Status/caseType/${caseTypeId}`,
    data: {},
    isAuth: false,
  };
  return get(request);
};

const getStampDetails = () => {
  const request = {
    subUrl: `Status/estamp-details`,
    data: {},
    isAuth: false,
  };
  return get(request);
};

const updateCaseStatus = (payload: any) => {
  const request = {
    subUrl: `Status/update-case-status`,
    data: payload,
    isAuth: false,
  };
  return put(request);
};

const sendDocument = (payload: any) => {
  const request = {
    subUrl: `Status/senddocumentforsign`,
    data: payload,
    isAuth: false,
    dataType: "form-data",
  };
  return post(request);
};

const eSignDocument = (payload: any) => {
  const request = {
    subUrl: `Status/esign-document`,
    data: payload,
    isAuth: false,
    dataType: "form-data",
  };
  return post(request);
};

const eStampDocument = (payload: any) => {
  const request = {
    subUrl: `Status/esign-document`, // Same endpoint used for both
    data: payload,
    isAuth: false,
    dataType: "form-data",
  };
  return post(request);
};

const getFinalStatuses = () => {
  const request = {
    subUrl: `Status/final-statuses`,
    isAuth: false,
  };
  return get(request);
};

const StatusApi = {
  caseStatus,
  getStampDetails,
  updateCaseStatus,
  sendDocument,
  eSignDocument,
  eStampDocument,
  getFinalStatuses,
};

export default StatusApi;
